import type {
  PresignFields,
  StorageFileRecordSubmit,
} from 'hb-react/shared/hooks/useStorage/types';

import { CACHE_STORAGE, PRESIGNED_FILE_KEY } from '../constants';

export const getShrineId = (key: string) => key.replace('shrine_cache/', '');

export const getFormData = (fields: PresignFields, file: File) => {
  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => formData.append(key, value));

  formData.append(PRESIGNED_FILE_KEY, file);

  return formData;
};

export const formatAttachment = ({
  file,
  id,
  storage = CACHE_STORAGE,
}: {
  file: File;
  id: string | number;
  storage?: string;
}): StorageFileRecordSubmit => ({
  id,
  storage,
  metadata: {
    size: file.size,
    filename: file.name,
    mime_type: file.type,
  },
});
